import React, { Component } from 'react';
import cx from 'classnames';
import { SketchPicker } from 'react-color';
import { WRAPPER, SAVE_BUTTON, CONTENT } from '../styles/colorPicker';
import Input from '../../Input';
import Button from '../../Button';













class ColorPicker extends Component {
  static defaultProps = {
    initialValue: { hex: '000000', label: '' }
  };

  constructor(props) {
    super(props);

    this.state = {
      hex: props.initialValue.hex,
      label: props.initialValue.label
    };
  }

  handleColorChange = ({ hex }) => {
    this.setState({ hex: hex.substring(1) });
  };

  handleColorChangeComplete = ({ hex }) => {
    const { onSaveColor, colourOnly, withHash } = this.props;

    if (colourOnly) {
      onSaveColor({
        hex: withHash ? hex : hex.substring(1)
      });
    }
  };

  handleLabelChange = ({ target: { value } }) => {
    this.setState({ label: value });
  };

  handleColorSave = () => {
    const { onSaveColor, withHash } = this.props;
    const { hex, label } = this.state;

    onSaveColor({
      hex: withHash ? `#${hex}` : hex,
      label
    });
  };

  render() {
    const { hex, label } = this.state;
    const { colourOnly } = this.props;

    if (colourOnly) {
      return (
        <div className={cx('color-picker', WRAPPER)}>
          <SketchPicker
            disableAlpha
            color={`#${hex}`}
            onChange={this.handleColorChange}
            onChangeComplete={this.handleColorChangeComplete} />

        </div>);

    }

    return (
      <div className={cx('color-picker', WRAPPER)}>
        <SketchPicker
          disableAlpha
          color={`#${hex}`}
          onChange={this.handleColorChange} />

        <hr />
        <div className={cx('color-picker__content', CONTENT)}>
          <Input
            id="colour-name"
            label="Color Name"
            defaultValue={label}
            className="color-picker__name-input"
            placeholder="Color Name"
            onChange={this.handleLabelChange} />

          <Button
            className={cx('color-picker__name-button', SAVE_BUTTON)}
            onClick={this.handleColorSave}>

            Save Changes
          </Button>
        </div>
      </div>);

  }
}

export default ColorPicker;